import { log } from '@economic/react-app';

import eventApiClient from '../api/eventApiClient';

export default function track(areaName: string, action: string, trackingData?: object): void {
    eventApiClient
        .post('/EmitEvent', {
            action,
            areaName,
            data: trackingData || {},
        })
        .catch((error: any) => {
            if (error?.response) {
                log.error(error);
            }
        });
}
